'use client'
import Image, { ImageProps } from 'next/image'
import { Ref, useState } from 'react'
import './styles.scss'

type ImageWithFallbackProps = ImageProps & { ref?: Ref<HTMLImageElement> }

export const ImageWithFallback = ({
  ref,
  ...props
}: ImageWithFallbackProps) => {
  const [hasError, setHasError] = useState(!props.src)

  if (hasError) {
    return (
      <div className="image-fallback">
        <span>Sem imagem disponível</span>
      </div>
    )
  }

  return (
    <Image
      ref={ref}
      {...props}
      alt={props.alt ?? ''}
      onError={() => setHasError(true)}
    />
  )
}
